import type { Step } from "@views/Upholstery/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

export interface UpholsteryStepsV2State {
  /** Global Build / Kit / Pattern / Design / Material steps from Dato. */
  steps: Step[]
  loading: boolean
  error: string | null
  fetchedAt: number | null
  actions: {
    setSteps: (steps: Step[]) => void
    setLoading: (loading: boolean) => void
    setError: (error: string | null) => void
    reset: () => void
  }
}

const initialState = {
  steps: [] as Step[],
  loading: false,
  error: null as string | null,
  fetchedAt: null as number | null,
}

export const useUpholsteryStepsV2Store = create<UpholsteryStepsV2State>()(
  devtools(
    (set) => ({
      ...initialState,
      actions: {
        setSteps: (steps) =>
          set({
            steps,
            loading: false,
            error: null,
            fetchedAt: Date.now(),
          }),
        setLoading: (loading) => set({ loading }),
        setError: (error) => set({ error, loading: false }),
        reset: () => set(initialState),
      },
    }),
    { name: "UpholsteryStepsV2Store" }
  )
)
